import React from "react";
import InterviewMode from "../../../components/InterviewMode/InterviewMode";

function InterviewModePage() {
  return <InterviewMode />;
}

export default InterviewModePage;
